import { Link } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Breadcrumb from '@/components/Breadcrumb';
import { hotTopics } from '@/mocks/hotTopics';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: '关于我们 - 吃瓜爆料',
      description: '吃瓜爆料是最懂吃瓜的中文娱乐爆料社区，实时更新全网热门吃瓜事件、明星八卦与网红黑料。',
      url: 'http://94exue.cn/about',
      mainEntity: {
        '@type': 'Organization',
        name: '吃瓜爆料',
        url: 'http://94exue.cn/',
        logo: 'http://94exue.cn/logo.png',
        description: '全网热门吃瓜事件实时更新平台',
        sameAs: [
          'http://94exue.cn/chiguabaoliao',
        ],
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: '客服',
          email: 'hello@94exue.cn',
          availableLanguage: 'Chinese',
        },
      },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'http://94exue.cn/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
          item: 'http://94exue.cn/about',
        },
      ],
    },
  ],
};

export default function About() {
  const stats = [
    { value: '500万+', label: '月活跃用户', icon: 'ri-user-smile-line' },
    { value: '10万+', label: '累计爆料', icon: 'ri-file-list-3-line' },
    { value: '98%', label: '用户满意度', icon: 'ri-emotion-happy-line' },
    { value: '24h', label: '实时更新', icon: 'ri-time-line' },
  ];

  const features = [
    {
      title: '实时更新',
      desc: '7x24小时不间断追踪全网热点，确保您第一时间获取最新瓜料',
      icon: 'ri-flashlight-line',
    },
    {
      title: '内容严谨',
      desc: '专业编辑团队严格审核每一条爆料，力求真实可靠',
      icon: 'ri-shield-check-line',
    },
    {
      title: '独家爆料',
      desc: '拥有广泛的圈内人脉，经常获取第一手独家劲爆内容',
      icon: 'ri-vip-crown-line',
    },
    {
      title: '社区互动',
      desc: '每日大赛投票、瓜友评论互动，让吃瓜变得更有趣',
      icon: 'ri-chat-smile-3-line',
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 吃瓜爆料"
        description="吃瓜爆料是最懂吃瓜的中文娱乐爆料社区，实时更新全网热门吃瓜事件、明星八卦与网红黑料。了解我们的品牌故事、平台荣誉与联系方式。"
        canonical="http://94exue.cn/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />

      <main className="pt-16">
        {/* Hero Section */}
        <section className="relative min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20night%20scene%20of%20crowded%20urban%20street%20with%20neon%20signs%20and%20mysterious%20atmospheric%20lighting%2C%20deep%20emerald%20green%20and%20warm%20amber%20color%20palette%2C%20paparazzi%20style%20energy%2C%20abstract%20artistic%20interpretation%20of%20gossip%20and%20secrets%20unfolding%2C%20editorial%20photography%20with%20strong%20contrast%20and%20moody%20atmosphere&width=1920&height=800&seq=about-hero&orientation=landscape"
              alt="关于吃瓜爆料"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/50" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-12 lg:px-20 pt-8">
            <div className="max-w-3xl">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
                关于吃瓜爆料
              </h1>
              <p className="text-base md:text-lg text-white/80 max-w-lg leading-relaxed">
                做最懂吃瓜的中文娱乐爆料社区，让每一位瓜友都能第一时间吃到最新鲜的瓜。
              </p>
            </div>
          </div>

          <div className="absolute bottom-6 left-0 right-0 text-center z-10">
            <p className="text-5xl md:text-7xl font-heading font-black text-white/15 tracking-tight">
              吃瓜爆料
            </p>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="bg-background-50 border-b border-background-200/50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: '关于我们' }]} />
          </div>
        </div>

        {/* Brand Intro Section */}
        <section className="bg-background-50 py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
              <div>
                <span className="inline-flex items-center px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
                  品牌介绍
                </span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-snug mb-4">
                  全网热门吃瓜事件
                  <br />
                  实时更新平台
                </h2>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
                  吃瓜爆料成立于2023年，是国内领先的中文娱乐爆料资讯平台。我们专注于追踪全网热门吃瓜事件，覆盖明星八卦、网红黑料、社会热点等多个领域。
                </p>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
                  平台汇聚了一批资深娱乐记者、圈内知情人和专业编辑团队，致力于为用户提供最及时、最劲爆、最真实的吃瓜内容。我们的口号是："吃瓜不迷路，爆料就现在！"
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {features.map((feature) => (
                    <div key={feature.title} className="p-4 rounded-xl bg-background-100 border border-background-200/50">
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-2">
                        <i className={`${feature.icon} text-lg`} />
                      </div>
                      <h4 className="text-sm font-semibold text-foreground-800 mb-1">{feature.title}</h4>
                      <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-5 md:p-6 rounded-xl bg-foreground-800 text-white">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-xs text-white/50">平台宣言</span>
                  <div className="flex gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-white/30" />
                    <span className="w-1.5 h-1.5 rounded-full bg-white/30" />
                    <span className="w-1.5 h-1.5 rounded-full bg-white/30" />
                  </div>
                </div>
                <p className="text-lg md:text-xl font-medium leading-relaxed mb-6 text-white/90">
                  "我们相信，每一个真相都值得被看见。吃瓜爆料存在的意义，就是打破信息壁垒，让公众能够及时了解那些隐藏在光鲜表象之下的真实故事。"
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2.5">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20confident%20Chinese%20male%20founder%20in%20his%2030s%20with%20intelligent%20expression%2C%20wearing%20modern%20blazer%2C%20neutral%20warm%20background%2C%20clean%20studio%20lighting%2C%20editorial%20style&width=100&height=100&seq=founder-avatar&orientation=squarish"
                      alt="平台创始人"
                      className="w-9 h-9 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-xs font-medium">陈明远</p>
                      <p className="text-xs text-white/50">吃瓜爆料创始人</p>
                    </div>
                  </div>
                  <Link
                    to="/"
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/15 text-white hover:bg-white/25 transition-colors"
                  >
                    <i className="ri-arrow-right-line text-sm" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="bg-background-100 py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                平台数据 <span className="text-primary-500">荣誉展示</span>
              </h2>
              <p className="text-sm text-foreground-500">数字见证实力，口碑铸就品牌</p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {stats.map((stat) => (
                <div key={stat.label} className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center hover:-translate-y-1 transition-all">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className={`${stat.icon} text-xl`} />
                  </div>
                  <p className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1">{stat.value}</p>
                  <p className="text-xs text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Topics Horizontal Scroll */}
        <section className="bg-background-50 py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                我们追踪过的 <span className="text-primary-500">重磅瓜料</span>
              </h2>
              <p className="text-sm text-foreground-500">每一个热门话题背后，都有吃瓜爆料的身影</p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {hotTopics.slice(0, 4).map((topic) => (
                <Link
                  key={topic.id}
                  to={`/article/${topic.id.replace('hot', 'article')}`}
                  className="group block rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all hover:-translate-y-1"
                >
                  <div className="relative aspect-square overflow-hidden">
                    <img
                      src={topic.image}
                      alt={topic.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="inline-flex items-center px-2 py-0.5 bg-primary-500 text-white text-xs font-bold rounded-full">
                        {topic.tag}
                      </span>
                    </div>
                  </div>
                  <div className="p-3 md:p-4">
                    <h3 className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-1">
                      {topic.title}
                    </h3>
                    <p className="text-xs text-foreground-400">
                      {topic.hotValue >= 10000 ? `${(topic.hotValue / 10000).toFixed(1)}万` : topic.hotValue} 热度
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="bg-secondary-50 py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                <i className="ri-contacts-line" />
                联系我们
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                欢迎与我们联系
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-mail-line text-xl" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">hello@94exue.cn</p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-send-plane-line text-xl" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">投稿爆料</h3>
                <p className="text-xs text-foreground-500">hello@94exue.cn</p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className="ri-shield-line text-xl" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">侵权投诉</h3>
                <p className="text-xs text-foreground-500">hello@94exue.cn</p>
              </div>
            </div>

            <div className="mt-8 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/50 max-w-4xl mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-3">关注我们</h4>
                  <div className="flex items-center gap-3">
                    <a
                      href="#"
                      rel="nofollow"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 hover:bg-primary-500 hover:text-white transition-colors"
                      aria-label="站内动态"
                    >
                      <i className="ri-chat-1-fill text-lg" />
                    </a>
                    <a
                      href="#"
                      rel="nofollow"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 hover:bg-accent-500 hover:text-white transition-colors"
                      aria-label="微信"
                    >
                      <i className="ri-wechat-fill text-lg" />
                    </a>
                    <a
                      href="#"
                      rel="nofollow"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-secondary-500 hover:text-white transition-colors"
                      aria-label="短讯"
                    >
                      <i className="ri-notification-3-fill text-lg" />
                    </a>
                  </div>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-800 mb-3">平台信息</h4>
                  <div className="space-y-1.5 text-xs text-foreground-500">
                    <p>平台名称：吃瓜爆料</p>
                    <p>运营主体：吃瓜网络科技有限公司</p>
                    <p>成立时间：2023年</p>
                    <p>服务地区：中国大陆</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative min-h-[400px] md:min-h-[480px] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20wide%20panoramic%20scene%20of%20giant%20watermelon%20field%20under%20dramatic%20sunset%20sky%20with%20golden%20hour%20lighting%2C%20warm%20amber%20and%20deep%20green%20color%20palette%2C%20surreal%20dreamlike%20atmosphere%2C%20editorial%20landscape%20photography%20with%20strong%20visual%20impact%20and%20moody%20cinematic%20tone&width=1920&height=800&seq=about-cta&orientation=landscape"
              alt="加入吃瓜社区"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/50" />
          </div>

          <div className="relative z-10 w-full px-4 md:px-12 lg:px-20">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
              <div>
                <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight mb-4">
                  加入吃瓜社区
                </h2>
                <Link
                  to="/"
                  className="inline-flex items-center gap-3 px-6 py-3 bg-white text-foreground-900 rounded-full text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap"
                >
                  开始吃瓜
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 text-white">
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </Link>
              </div>
              <p className="text-sm text-white/80 max-w-sm leading-relaxed lg:text-right">
                做最懂吃瓜的人，从这里开始。全网热门吃瓜事件实时更新，精彩内容每日不打烊。
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
